import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { User } from '../types/User';
import { logout } from './authSlice';

const initialState: User = {
  id: '',
  email: localStorage.getItem('email') ?? '',
  firstName: null,
  lastName: null,
  imageURL: null,
  createdAt: '',
  org: {
    id: '',
    name: '',
    country: '',
    color: '',
    ownerId: '',
    status: 'ACTIVE',
    taxId: '',
  },
  role: '',
  username: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      localStorage.setItem('email', action.payload.email);
      return {
        ...state,
        ...action.payload,
      };
    },

    setEmail: (state, action: PayloadAction<string>) => {
      localStorage.setItem('email', action.payload);
      return {
        ...state,
        email: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => {
      localStorage.removeItem('email');
      return { ...initialState, email: '' };
    });
  },
});

export const { setUser, setEmail } = userSlice.actions;

export default userSlice.reducer;
